import React, { useEffect } from 'react';
import anime from 'animejs/lib/anime.es.js';
 
/* ------------------ ORIGINAL SAMPLES (1–14) ------------------ */
 
// Sample 1: Pure CSS Bars & Text
const Sample1 = () => (
  <div className="sample sample1">
    <h2>Sample 1: </h2>
    <div className="logo-container">
      {[...Array(9)].map((_, i) => (
        <div key={i} className="bar"></div>
      ))}
    </div>
    <div className="logo-text">SAISATWIK</div>
  </div>
);
 
// Sample 2: Multi-Color Bars & Sliding Text
const Sample2 = () => (
  <div className="sample sample2">
    <h2>Sample 2: </h2>
    <div className="logo-container">
      {[...Array(9)].map((_, i) => (
        <div key={i} className="bar"></div>
      ))}
    </div>
    <div className="logo-text">SAISATWIK</div>
  </div>
);
 
// Sample 3: SVG Animation (Rectangles filling)
const Sample3 = () => (
  <div className="sample sample3">
    <h2>Sample 3: </h2>
    <svg width="300" height="150">
      <rect x="10" y="10" width="20" height="100" fill="#ff4757">
        <animate attributeName="height" from="0" to="100" dur="0.8s" begin="0.2s" fill="freeze" />
      </rect>
      <rect x="40" y="10" width="20" height="100" fill="#ffa502">
        <animate attributeName="height" from="0" to="100" dur="0.8s" begin="0.4s" fill="freeze" />
      </rect>
      <rect x="70" y="10" width="20" height="100" fill="#1e90ff">
        <animate attributeName="height" from="0" to="100" dur="0.8s" begin="0.6s" fill="freeze" />
      </rect>
      <rect x="100" y="10" width="20" height="100" fill="#2ed573">
        <animate attributeName="height" from="0" to="100" dur="0.8s" begin="0.8s" fill="freeze" />
      </rect>
      <rect x="130" y="10" width="20" height="100" fill="#eccc68">
        <animate attributeName="height" from="0" to="100" dur="0.8s" begin="1s" fill="freeze" />
      </rect>
      <rect x="160" y="10" width="20" height="100" fill="#ff7f50">
        <animate attributeName="height" from="0" to="100" dur="0.8s" begin="1.2s" fill="freeze" />
      </rect>
      <rect x="190" y="10" width="20" height="100" fill="#7bed9f">
        <animate attributeName="height" from="0" to="100" dur="0.8s" begin="1.4s" fill="freeze" />
      </rect>
      <rect x="220" y="10" width="20" height="100" fill="#70a1ff">
        <animate attributeName="height" from="0" to="100" dur="0.8s" begin="1.6s" fill="freeze" />
      </rect>
      <rect x="250" y="10" width="20" height="100" fill="#eccc68">
        <animate attributeName="height" from="0" to="100" dur="0.8s" begin="1.8s" fill="freeze" />
      </rect>
      <text x="150" y="140" textAnchor="middle" className="svg-text">SAISATWIK</text>
    </svg>
  </div>
);
 
// Sample 4: Anime.js – Bars & Text
const Sample4 = () => {
  useEffect(() => {
    anime.timeline()
      .add({
        targets: '.sample4 .bar',
        scaleY: [0, 1],
        delay: anime.stagger(200),
        duration: 800,
        easing: 'easeOutElastic(1, .8)',
      })
      .add({
        targets: '.sample4 .logo-text',
        opacity: [0, 1],
        translateY: [20, 0],
        duration: 1000,
        easing: 'easeOutExpo',
      });
  }, []);
  return (
    <div className="sample sample4">
      <h2>Sample 4: </h2>
      <div className="logo-container">
        {[...Array(9)].map((_, i) => (
          <div key={i} className="bar" style={{ background: '#444' }}></div>
        ))}
      </div>
      <div className="logo-text">SAISATWIK</div>
    </div>
  );
};
 
// Sample 5: Text Color Transition
const Sample5 = () => (
  <div className="sample sample5">
    <h2>Sample 5: </h2>
    <div className="text-only">SAISATWIK</div>
  </div>
);
 
// Sample 6: Glowing Text Animation
const Sample6 = () => (
  <div className="sample sample6">
    <h2>Sample 6: </h2>
    <div className="text-glow">SAISATWIK</div>
  </div>
);
 
// Sample 7: Rotating Circles
const Sample7 = () => (
  <div className="sample sample7">
    <h2>Sample 7: </h2>
    <div className="circle-container">
      <div className="big-circle"></div>
      <div className="small-circle"></div>
    </div>
  </div>
);
 
// Sample 8: 3D Flipping Circle
const Sample8 = () => (
  <div className="sample sample8">
    <h2>Sample 8: </h2>
    <div className="flip-container">
      <div className="flip-circle"></div>
    </div>
  </div>
);
 
// Sample 9: Pulsing Circle Cluster
const Sample9 = () => {
  const angles = [0, 60, 120, 180, 240, 300];
  return (
    <div className="sample sample9">
      <h2>Sample 9: </h2>
      <div className="pulse-container">
        {angles.map((angle, i) => (
          <div
            key={i}
            className="pulse-wrapper"
            style={{ transform: `rotate(${angle}deg) translate(80px) rotate(-${angle}deg)` }}
          >
            <div className="pulse-circle" style={{ background: i % 2 === 0 ? '#f5961c' : '#2970fa' }}></div>
          </div>
        ))}
      </div>
    </div>
  );
};
 
// Sample 10: Jumping Box Switch
const Sample10 = () => (
  <div className="sample sample10">
    <h2>Sample 10: </h2>
    <div className="box-switch-container">
      <div className="box box1"></div>
      <div className="box box2"></div>
    </div>
  </div>
);
 
// Sample 11: Stairs & Circle Jump (Bouncing Along Stairs)
// The stairs are absolutely positioned and the ball now follows a parabolic arc relative to them.
const Sample11 = () => (
  <div className="sample sample11">
    <h2>Sample 11: </h2>
    <div className="stairs-container">
      <div className="stair" style={{ left: '0px', bottom: '0px' }}></div>
      <div className="stair" style={{ left: '80px', bottom: '20px' }}></div>
      <div className="stair" style={{ left: '160px', bottom: '40px' }}></div>
      <div className="stair" style={{ left: '240px', bottom: '60px' }}></div>
      <div className="stair" style={{ left: '320px', bottom: '80px' }}></div>
      <div className="circle-jumper"></div>
    </div>
  </div>
);
 
// Sample 12: Rotating Arc Spinner
const Sample12 = () => (
  <div className="sample sample12">
    <h2>Sample 12: </h2>
    <div className="spinner"></div>
  </div>
);
 
// Sample 13: Bouncing Dots
const Sample13 = () => (
  <div className="sample sample13">
    {/* <h2>Sample 13:</h2> */}
    <div className="dots">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  </div>
);
 
// Sample 14: Dot Wave
const Sample14 = () => (
  <div className="sample sample14">
    <h2>Sample 14: </h2>
    <div className="dot-wave">
      <div className="wave-dot"></div>
      <div className="wave-dot"></div>
      <div className="wave-dot"></div>
      <div className="wave-dot"></div>
      <div className="wave-dot"></div>
    </div>
  </div>
);
 
/* ------------------ NEW CREATIVE SAMPLES (15–30) ------------------ */
 
// Sample 15: Liquid Fill Number (Hollow text filling with “liquid”)
const Sample15 = () => (
  <div className="sample sample15">
    <h2>Sample 15: </h2>
    <svg className="liquid-logo" viewBox="0 0 200 100">
      <defs>
        <clipPath id="textClip">
          <text x="50%" y="70%" textAnchor="middle" className="liquid-text">100%</text>
        </clipPath>
      </defs>
      <rect className="liquid-fill" x="0" y="100" width="200" height="100" clipPath="url(#textClip)" />
      <text x="50%" y="70%" textAnchor="middle" className="liquid-text-outline">100%</text>
    </svg>
  </div>
);
 
// Sample 16: Radial Progress Bar
const Sample16 = () => (
  <div className="sample sample16">
    <h2>Sample 16: </h2>
    <svg className="radial-progress" viewBox="0 0 100 100">
      <circle className="progress-bg" cx="50" cy="50" r="45" />
      <circle className="progress-bar" cx="50" cy="50" r="45" />
      <text x="50%" y="55%" textAnchor="middle" className="progress-text">75%</text>
    </svg>
  </div>
);
 
// Sample 17: Rotating Text Circle
const Sample17 = () => (
  <div className="sample sample17">
    <h2>Sample 17: </h2>
    <div className="rotating-text-circle">
      <span>SAISATWIK &nbsp; SAISATWIK &nbsp; SAISATWIK</span>
    </div>
  </div>
);
 
// Sample 18: Shattering Letters
const Sample18 = () => (
  <div className="sample sample18">
    <h2>Sample 18: </h2>
    <div className="shatter-text">
      {"SAISATWIK".split("").map((letter, i) => (
        <span key={i} className="shatter-letter">{letter}</span>
      ))}
    </div>
  </div>
);
 
// Sample 19: Morphing Shapes
const Sample19 = () => (
  <div className="sample sample19">
    <h2>Sample 19: </h2>
    <svg className="morph-shape" viewBox="0 0 100 100">
      <path d="M50 10 L90 90 L10 90 Z">
        <animate attributeName="d" values="M50 10 L90 90 L10 90 Z; M10 10 L90 10 L50 90 Z; M50 10 L90 90 L10 90 Z" dur="3s" repeatCount="indefinite" />
      </path>
    </svg>
  </div>
);
 
// Sample 20: Particle Explosion
const Sample20 = () => (
  <div className="sample sample20">
    <h2>Sample 20:</h2>
    <div className="particle-explosion">
      {[...Array(20)].map((_, i) => (
        <div key={i} className="particle" style={{ '--dx': Math.random() * 2 - 1, '--dy': Math.random() * 2 - 1 }}></div>
      ))}
    </div>
  </div>
);
 
// Sample 21: Animated Gradient Logo
const Sample21 = () => (
  <div className="sample sample21">
    <h2>Sample 21: </h2>
    <div className="gradient-logo">SAISATWIK</div>
  </div>
);
 
// Sample 22: Circular Wave Fill
const Sample22 = () => (
  <div className="sample sample22">
    <h2>Sample 22: </h2>
    <svg className="wave-circle" viewBox="0 0 100 100">
      <circle className="wave-bg" cx="50" cy="50" r="45" />
      <path className="wave" d="M0,50 Q50,70 100,50 T200,50" />
      <text x="50%" y="55%" textAnchor="middle" className="wave-text">SAISATWIK</text>
    </svg>
  </div>
);
 
// Sample 23: 3D Cube Rotation
const Sample23 = () => (
  <div className="sample sample23">
    <h2>Sample 23: </h2>
    <div className="cube">
      <div className="cube-face front">L</div>
      <div className="cube-face back">P</div>
      <div className="cube-face right">T</div>
      <div className="cube-face left">S</div>
      <div className="cube-face top">A</div>
      <div className="cube-face bottom">T</div>
    </div>
  </div>
);
 
// Sample 24: Neon Flicker Text
const Sample24 = () => (
  <div className="sample sample24">
    <h2>Sample 24: </h2>
    <div className="neon-text">SAISATWIK</div>
  </div>
);
 
// Sample 25: SVG Path Drawing Logo
const Sample25 = () => (
  <div className="sample sample25">
    <h2>Sample 25:</h2>
    <svg className="path-drawing" viewBox="0 0 300 100">
      <path className="logo-path" d="M10 80 Q95 10 180 80 T350 80" fill="none" stroke="#f5961c" strokeWidth="4">
        <animate attributeName="stroke-dashoffset" from="300" to="0" dur="3s" fill="freeze" />
      </path>
      <text x="50%" y="90%" textAnchor="middle" className="logo-text">SAISATWIK</text>
    </svg>
  </div>
);
 
// Sample 26: Typewriter Effect
const Sample26 = () => (
  <div className="sample sample26">
    <h2>Sample 26: </h2>
    <div className="typewriter">SAISATWIK</div>
  </div>
);
 
// Sample 27: Water Ripple Effect
const Sample27 = () => (
  <div className="sample sample27">
    <h2>Sample 27: </h2>
    <div className="ripple-logo">SAISATWIK</div>
  </div>
);
 
// Sample 28: Floating Letters with Parallax
const Sample28 = () => (
  <div className="sample sample28">
    <h2>Sample 28: </h2>
    <div className="floating-letters">
      {"SAISATWIK".split("").map((letter, i) => (
        <span key={i} className="floating-letter">{letter}</span>
      ))}
    </div>
  </div>
);
 
// Sample 29: Hexagon Mosaic Animation
const Sample29 = () => (
  <div className="sample sample29">
    <h2>Sample 29: </h2>
    <div className="hexagon-mosaic">
      {[...Array(12)].map((_, i) => (
        <div key={i} className="hexagon"></div>
      ))}
    </div>
  </div>
);
 
// Sample 30: Pulsating Logo with Blur Effect
const Sample30 = () => (
  <div className="sample sample30">
    <h2>Sample 30: </h2>
    <div className="pulsating-logo">SAISATWIK</div>
  </div>
);
 
/* --------------------- MAIN COMPONENT --------------------- */
const Logo = () => {
  return (
    <div className="App">
      <style>{`
        /* GLOBAL STYLES */
        body {
          margin: 0;
          font-family: sans-serif;
          background: #222;
          color: #fff;
        }
        .App {
          padding: 20px;
        }
        .sample {
          margin: 40px 0;
          text-align: center;
        }
        h2 {
          margin-bottom: 20px;
        }
        /* ------------------- SAMPLES 1–14 (Original) ------------------- */
        .logo-container {
          display: flex;
          gap: 5px;
          justify-content: center;
          margin-bottom: 20px;
        }
        .bar {
          width: 20px;
          height: 100px;
          background: #444;
          opacity: 0;
          transform: scaleY(0);
          animation: fillBar 1s forwards;
        }
        @keyframes fillBar {
          0% { opacity: 0; transform: scaleY(0.5); }
          100% { opacity: 1; transform: scaleY(1); }
        }
        .sample1 .bar { background: #ff0066; }
        .sample1 .logo-text {
          animation: textFade 1s forwards;
          animation-delay: 2s;
          font-size: 48px;
          text-shadow: 0 0 10px #ff0066;
          opacity: 0;
        }
        @keyframes textFade {
          0% { opacity: 0; transform: scale(0.8); }
          100% { opacity: 1; transform: scale(1); }
        }
        .sample2 .bar:nth-child(1) { animation-delay: 0.2s; background: #e74c3c; }
        .sample2 .bar:nth-child(2) { animation-delay: 0.4s; background: #f39c12; }
        .sample2 .bar:nth-child(3) { animation-delay: 0.6s; background: #f1c40f; }
        .sample2 .bar:nth-child(4) { animation-delay: 0.8s; background: #2ecc71; }
        .sample2 .bar:nth-child(5) { animation-delay: 1s; background: #1abc9c; }
        .sample2 .bar:nth-child(6) { animation-delay: 1.2s; background: #3498db; }
        .sample2 .bar:nth-child(7) { animation-delay: 1.4s; background: #9b59b6; }
        .sample2 .bar:nth-child(8) { animation-delay: 1.6s; background: #e67e22; }
        .sample2 .bar:nth-child(9) { animation-delay: 1.8s; background: #e84393; }
        .sample2 .logo-text {
          animation: textGlow 1s forwards;
          animation-delay: 2.2s;
          font-size: 48px;
          text-shadow: 0 0 15px #fff;
          opacity: 0;
        }
        @keyframes textGlow {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .svg-text {
          fill: #00d1b2;
          font-size: 48px;
          opacity: 0;
          animation: svgTextAppear 1s forwards;
          animation-delay: 3s;
        }
        @keyframes svgTextAppear {
          0% { opacity: 0; }
          100% { opacity: 1; }
        }
        .sample5 .text-only {
          font-size: 48px;
          font-weight: bold;
          opacity: 0;
          animation: colorFill 2s ease-out forwards;
        }
        @keyframes colorFill {
          0% { opacity: 0; color: #f5961c; transform: scale(0.8); }
          50% { opacity: 1; transform: scale(1.1); }
          100% { opacity: 1; color: #2970fa; transform: scale(1); }
        }
        .sample6 .text-glow {
          font-size: 48px;
          font-weight: bold;
          color: #2970fa;
          opacity: 0;
          animation: glow 2s ease-out forwards;
        }
        @keyframes glow {
          0% { opacity: 0; text-shadow: 0 0 5px #f5961c; transform: scale(0.8); }
          50% { opacity: 1; text-shadow: 0 0 20px #f5961c; transform: scale(1.05); }
          100% { opacity: 1; text-shadow: 0 0 10px #2970fa; transform: scale(1); }
        }
        .sample7 .circle-container {
          width: 150px;
          height: 150px;
          position: relative;
          margin: auto;
          animation: rotate360 4s linear infinite;
        }
        .sample7 .big-circle {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background: #f5961c;
          position: absolute;
          top: 25px;
          left: 25px;
        }
        .sample7 .small-circle {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: #2970fa;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(50px, -15px);
        }
        @keyframes rotate360 {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .sample8 {
          perspective: 800px;
        }
        .sample8 .flip-circle {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background: linear-gradient(45deg, #f5961c, #2970fa);
          margin: auto;
          animation: flip 3s infinite;
          transform-style: preserve-3d;
        }
        @keyframes flip {
          from { transform: rotateY(0deg); }
          to { transform: rotateY(360deg); }
        }
        .sample9 .pulse-container {
          position: relative;
          width: 200px;
          height: 200px;
          margin: auto;
        }
        .sample9 .pulse-wrapper {
          position: absolute;
          top: 50%;
          left: 50%;
        }
        .sample9 .pulse-circle {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          animation: pulse 2s infinite ease-in-out;
        }
        @keyframes pulse {
          0%, 100% { transform: scale(0.8); }
          50% { transform: scale(1.2); }
        }
        /* ------------------- SAMPLES 10–14 (New Loading Samples) ------------------- */
        .sample10 .box-switch-container {
          position: relative;
          width: 200px;
          height: 100px;
          margin: auto;
        }
        .sample10 .box {
          position: absolute;
          width: 80px;
          height: 80px;
          border-radius: 8px;
        }
        .sample10 .box1 {
          background-color: #f5961c;
          left: 0;
          top: 10px;
          animation: slideRight 2s ease-in-out forwards;
        }
        .sample10 .box2 {
          background-color: #2970fa;
          left: 120px;
          top: 10px;
          animation: jumpLeft 2s ease-in-out forwards;
        }
        @keyframes slideRight {
          0% { left: 0; }
          100% { left: 120px; }
        }
        @keyframes jumpLeft {
          0% { left: 120px; top: 10px; }
          50% { left: 60px; top: -30px; }
          100% { left: 0; top: 10px; }
        }
        .sample11 .stairs-container {
          position: relative;
          width: 400px;
          height: 150px;
          margin: auto;
        }
        .sample11 .stair {
          position: absolute;
          width: 60px;
          height: 20px;
          background: #f5961c;
          border-radius: 4px;
        }
        .sample11 .stair:nth-child(1) { left: 0; bottom: 0; }
        .sample11 .stair:nth-child(2) { left: 80px; bottom: 20px; }
        .sample11 .stair:nth-child(3) { left: 160px; bottom: 40px; }
        .sample11 .stair:nth-child(4) { left: 240px; bottom: 60px; }
        .sample11 .stair:nth-child(5) { left: 320px; bottom: 80px; }
        .sample11 .circle-jumper {
          position: absolute;
          width: 40px;
          height: 40px;
          background: #2970fa;
          border-radius: 50%;
          bottom: 0;
          left: 0;
          animation: jumpStairs 4s ease-in-out infinite;
        }
        @keyframes jumpStairs {
          0%   { transform: translate(0, 0) scale(1); }
          12.5%{ transform: translate(40px, -30px) scale(1.2); }
          25%  { transform: translate(80px, 0) scale(1); }
          37.5%{ transform: translate(120px, -30px) scale(1.2); }
          50%  { transform: translate(160px, 0) scale(1); }
          62.5%{ transform: translate(200px, -30px) scale(1.2); }
          75%  { transform: translate(240px, 0) scale(1); }
          87.5%{ transform: translate(280px, -30px) scale(1.2); }
          100% { transform: translate(320px, 0) scale(1); }
        }
        .sample12 .spinner {
          width: 50px;
          height: 50px;
          border: 5px solid #f5961c;
          border-top-color: #2970fa;
          border-radius: 50%;
          margin: auto;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .sample13 .dots {
          display: flex;
          justify-content: center;
          gap: 10px;
        }
        .sample13 .dot {
          width: 15px;
          height: 15px;
          background: #2970fa;
          border-radius: 50%;
          animation: bounce 1.2s infinite ease-in-out;
        }
        .sample13 .dot:nth-child(1) { animation-delay: 0; }
        .sample13 .dot:nth-child(2) { animation-delay: 0.2s; }
        .sample13 .dot:nth-child(3) { animation-delay: 0.4s; }
        @keyframes bounce {
          0%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-15px); }
        }
        .sample14 .dot-wave {
          display: flex;
          justify-content: center;
          gap: 5px;
        }
        .sample14 .wave-dot {
          width: 18px;
          height: 18px;
          background: #f5961c;
          border-radius: 50%;
          animation: wave 1.2s infinite ease-in-out;
        }
        .sample14 .wave-dot:nth-child(1) { animation-delay: 0; }
        .sample14 .wave-dot:nth-child(2) { animation-delay: 0.1s; }
        .sample14 .wave-dot:nth-child(3) { animation-delay: 0.2s; }
        .sample14 .wave-dot:nth-child(4) { animation-delay: 0.3s; }
        .sample14 .wave-dot:nth-child(5) { animation-delay: 0.4s; }
        @keyframes wave {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        /* ------------------- SAMPLES 15–30 (New Creative Ones) ------------------- */
        .liquid-logo { width: 200px; height: 100px; margin: auto; }
        .liquid-text { font-size: 60px; fill: #2970fa; }
        .liquid-text-outline { font-size: 60px; fill: none; stroke: #f5961c; stroke-width: 2; }
        .liquid-fill { fill: #f5961c; animation: liquidFill 3s ease-out forwards; }
        @keyframes liquidFill {
          0% { transform: translateY(100%); }
          100% { transform: translateY(0); }
        }
        .radial-progress { width: 100px; height: 100px; margin: auto; }
        .progress-bg { fill: none; stroke: #444; stroke-width: 10; }
        .progress-bar { fill: none; stroke: #f5961c; stroke-width: 10; stroke-dasharray: 283; stroke-dashoffset: 283; animation: progressFill 3s forwards; }
        .progress-text { font-size: 20px; fill: #fff; }
        @keyframes progressFill {
          0% { stroke-dashoffset: 283; }
          100% { stroke-dashoffset: 70; }
        }
        .rotating-text-circle {
          width: 200px;
          height: 200px;
          border: 2px solid #f5961c;
          border-radius: 50%;
          margin: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: rotate360 6s linear infinite;
        }
        .rotating-text-circle span { font-size: 20px; }
        .shatter-text { display: flex; justify-content: center; }
        .shatter-letter { font-size: 48px; opacity: 0; animation: shatter 2s forwards; }
        .shatter-letter:nth-child(1) { animation-delay: 0.1s; }
        .shatter-letter:nth-child(2) { animation-delay: 0.2s; }
        .shatter-letter:nth-child(3) { animation-delay: 0.3s; }
        .shatter-letter:nth-child(4) { animation-delay: 0.4s; }
        .shatter-letter:nth-child(5) { animation-delay: 0.5s; }
        .shatter-letter:nth-child(6) { animation-delay: 0.6s; }
        .shatter-letter:nth-child(7) { animation-delay: 0.7s; }
        .shatter-letter:nth-child(8) { animation-delay: 0.8s; }
        .shatter-letter:nth-child(9) { animation-delay: 0.9s; }
        @keyframes shatter {
          0% { transform: translateY(0); opacity: 0; }
          100% { transform: translateY(-20px) rotate(20deg); opacity: 1; }
        }
        .morph-shape { width: 100px; height: 100px; margin: auto; }
        .particle-explosion {
          position: relative;
          width: 100px;
          height: 100px;
          margin: auto;
        }
        .particle {
          position: absolute;
          width: 5px;
          height: 5px;
          background: #f5961c;
          border-radius: 50%;
          animation: particleExplode 2s infinite ease-out;
        }
        @keyframes particleExplode {
          0% { transform: translate(0, 0) scale(1); opacity: 1; }
          100% { transform: translate(calc(100px * var(--dx)), calc(100px * var(--dy))) scale(0.5); opacity: 0; }
        }
        .gradient-logo {
          font-size: 48px;
          font-weight: bold;
          background: linear-gradient(90deg, #f5961c, #2970fa);
          background-size: 200%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: gradientShift 3s infinite;
        }
        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .wave-circle { width: 100px; height: 100px; margin: auto; }
        .wave-bg { fill: none; stroke: #444; stroke-width: 5; }
        .wave { fill: none; stroke: #f5961c; stroke-width: 5; animation: waveFill 3s infinite; }
        @keyframes waveFill {
          0% { stroke-dasharray: 0, 100; }
          50% { stroke-dasharray: 100, 0; }
          100% { stroke-dasharray: 0, 100; }
        }
        .wave-text { font-size: 16px; fill: #fff; }
        .cube {
          width: 100px;
          height: 100px;
          position: relative;
          margin: auto;
          transform-style: preserve-3d;
          animation: cubeRotate 4s infinite linear;
        }
        .cube-face {
          position: absolute;
          width: 100px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          font-weight: bold;
          background: rgba(255,255,255,0.1);
          border: 1px solid #f5961c;
        }
        .cube-face.front { transform: translateZ(50px); }
        .cube-face.back { transform: rotateY(180deg) translateZ(50px); }
        .cube-face.right { transform: rotateY(90deg) translateZ(50px); }
        .cube-face.left { transform: rotateY(-90deg) translateZ(50px); }
        .cube-face.top { transform: rotateX(90deg) translateZ(50px); }
        .cube-face.bottom { transform: rotateX(-90deg) translateZ(50px); }
        @keyframes cubeRotate {
          0% { transform: rotateY(0deg); }
          100% { transform: rotateY(360deg); }
        }
        .neon-text {
          font-size: 48px;
          font-weight: bold;
          color: #2970fa;
          text-shadow: 0 0 10px #f5961c, 0 0 20px #f5961c, 0 0 30px #f5961c;
          animation: neonFlicker 3s infinite;
        }
        @keyframes neonFlicker {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        .path-drawing { width: 300px; height: 100px; margin: auto; }
        .logo-path { stroke-dasharray: 300; stroke-dashoffset: 300; animation: drawPath 3s forwards; }
        @keyframes drawPath {
          0% { stroke-dashoffset: 300; }
          100% { stroke-dashoffset: 0; }
        }
        .typewriter {
          font-size: 48px;
          border-right: 2px solid #f5961c;
          white-space: nowrap;
          overflow: hidden;
          width: 0;
          animation: typewriter 4s steps(10) forwards, blink 0.5s step-end infinite alternate;
        }
        @keyframes typewriter {
          from { width: 0; }
          to { width: 200px; }
        }
        @keyframes blink {
          from { border-color: transparent; }
          to { border-color: #f5961c; }
        }
        .ripple-logo {
          font-size: 48px;
          position: relative;
          display: inline-block;
        }
        .ripple-logo::after {
          content: '';
          position: absolute;
          left: 50%;
          top: 50%;
          width: 100%;
          height: 100%;
          background: rgba(249,150,28,0.3);
          border-radius: 50%;
          transform: translate(-50%, -50%) scale(0);
          animation: ripple 2s infinite;
        }
        @keyframes ripple {
          0% { transform: translate(-50%, -50%) scale(0); opacity: 1; }
          100% { transform: translate(-50%, -50%) scale(2); opacity: 0; }
        }
        .floating-letters { display: flex; justify-content: center; }
        .floating-letter { font-size: 48px; animation: float 3s infinite ease-in-out; }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .hexagon-mosaic {
          display: flex;
          flex-wrap: wrap;
          width: 180px;
          margin: auto;
          gap: 5px;
        }
        .hexagon {
          width: 50px;
          height: 50px;
          background: #2970fa;
          clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
          animation: hexPulse 2s infinite;
        }
        @keyframes hexPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.2); }
        }
        .pulsating-logo {
          font-size: 48px;
          font-weight: bold;
          color: #f5961c;
          animation: pulsate 2s infinite;
        }
        @keyframes pulsate {
          0%, 100% { transform: scale(1); filter: blur(0px); }
          50% { transform: scale(1.1); filter: blur(2px); }
        }
      `}</style>
       {/* <h1>Logo & Loading Samples</h1> */}
      {/* <Sample1 />
      <Sample2 />
      <Sample3 />
      <Sample4 />
      <Sample5 />
      <Sample6 />
      <Sample7 />
      <Sample8 />
      <Sample9 />
      <Sample10 />
      <Sample11 />
      <Sample12 /> */}
      <Sample13 />
      {/*<Sample14 />
      <Sample15 />
      <Sample16 />
      <Sample17 />
      <Sample18 />
       <Sample19 />
      <Sample20 />
      <Sample21 />
      <Sample22 />
      <Sample23 />
      <Sample24 /> 
      <Sample25 />
      <Sample26 />
      <Sample27 />
      <Sample28 />
      <Sample29 />
      <Sample30 /> */}
    </div>
  );
};
 
export default Logo;